import reducer from './reducers';

export { default as sharedTypes } from './types';

export default reducer;
